export default __webpack_public_path__ + "static/media/head04_zh_tw_sp.ae3fa522.png";